import { render, staticRenderFns } from "./FbSlider.vue?vue&type=template&id=10ac85ec"
import script from "./FbSlider.vue?vue&type=script&lang=js"
export * from "./FbSlider.vue?vue&type=script&lang=js"
import style0 from "./FbSlider.vue?vue&type=style&index=0&id=10ac85ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports